export default __webpack_public_path__ + "static/home_8-fae8bc01a81218c85baf0fb2c4da39cd.png";